import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumTransportationDistanceUnit implements BaseEnumType {
  private static allValues: EnumTransportationDistanceUnit[] = []; // make sure this is top-most
  
  public static none = new EnumTransportationDistanceUnit(0, "None", "enum_transportation_distance_unit_none");
  public static metricMetre = new EnumTransportationDistanceUnit(1, "MetricMetre", "enum_transportation_distance_unit_metric_metre");
  public static metricKilometre = new EnumTransportationDistanceUnit(2, "MetricKilometre", "enum_transportation_distance_unit_metric_kilometre");
  public static imperialFoot = new EnumTransportationDistanceUnit(3, "ImperialFoot", "enum_transportation_distance_unit_imperial_foot");
  public static imperialYard = new EnumTransportationDistanceUnit(4, "ImperialYard", "enum_transportation_distance_unit_imperial_yard");
  public static imperialMile = new EnumTransportationDistanceUnit(5, "ImperialMile", "enum_transportation_distance_unit_imperial_mile");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumTransportationDistanceUnit.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumTransportationDistanceUnit.none; }
  public isMetricMetre() { return this === EnumTransportationDistanceUnit.metricMetre; }
  public isMetricKilometre() { return this === EnumTransportationDistanceUnit.metricKilometre; }
  public isImperialFoot() { return this === EnumTransportationDistanceUnit.imperialFoot; }
  public isImperialYard() { return this === EnumTransportationDistanceUnit.imperialYard; }
  public isImperialMile() { return this === EnumTransportationDistanceUnit.imperialMile; }

  public static getValues(): readonly EnumTransportationDistanceUnit[] {
    return EnumTransportationDistanceUnit.allValues;
  }

  public static getValuesExcept0(): readonly EnumTransportationDistanceUnit[] {
    return EnumTransportationDistanceUnit.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumTransportationDistanceUnit {
    const found = EnumTransportationDistanceUnit.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumTransportationDistanceUnit - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumTransportationDistanceUnit): EnumTransportationDistanceUnit {
    const found = name ? EnumTransportationDistanceUnit.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumTransportationDistanceUnit - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumTransportationDistanceUnit>): boolean {
    return this.key === other?.key;
  }
}